import breakpoints from '../../../theme/breakpoints'
import theme from '../../../theme/news12'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`

  .card {
    display: block;
    width: 100%;
    height: 100%;
    padding: 20px 0;
    border-bottom: 1px solid ${redesignedTheme.colors.mist};
    background-color: ${redesignedTheme.colors.white};
  }
  
  .category .card {
    border-top: 1px solid ${theme.colors.lightGray3};
    border-bottom: 1px solid ${theme.colors.lightGray3};
  }
  
  .image-hd {
    display: inline-block;
    width: 200px;
    margin: 0;
    float: left;
  }
  
  .top {
    float: right;
    width: calc(100% - 216px);
    margin-top: 4px;
    margin-bottom: 0;
  }
  
  .card-title {
    float: right;
    width: calc(100% - 216px);
    margin-top: 12px;
    padding-right: 30px;
  }
  
  @media only screen and (max-width: ${breakpoints.md}px) {
    .card {
      padding: 20px 40px;
      margin-bottom: 10px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
      border: 1px solid ${theme.colors.lightGray3};
    }
  
    .card .card-content {
      border-bottom: none;
    }
  }
  
  @media only screen and (max-width: ${breakpoints.sm}px) {
    .card {
      padding: 11px 24px 0 24px;
      margin-bottom: 10px;
      border-bottom: none;
    }
    
    .card-content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      height: fit-content;
    }
    
    .top {
      order: -1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 0;
      width: 100%;
      line-height: 100%;
    }
    
    .duration-pill-container {
      top: 18px;
      right: 20px;
    }
    
    .image-hd {
      display: inline-block;
      padding-top: 0;
      width: 130px;
      height: 74px;
      margin: 10px 12px 16px 0px;
    }
    
    .timestamp {
      font-size: 13px;
    }
    
    .card-title {
      width: calc(100% - 150px);
      margin: 10px 0 16px 0;
      padding-right: 0;
    }
  }
`
